export const PasswordHintTestIds = {
  passwordSegment: 'password_progress',
  rule: 'password_rule',
  ruleSucces: 'password_rule_success',
  ruleError: 'password_rule_error',
  ruleText: 'password_rule_text'
} as const;
